module.exports = __webpack_public_path__ + "img/9B9B9B_1E1E1E_5C5C5C_444444-256px.a9133f15.png";